// Shared "saved"/retention messaging helper — used by the cart badge and the PDP continue panel.
(function () {
  const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const DAY_MS = 24 * 60 * 60 * 1000;

  function formatDate(epochMs) {
    const d = new Date(epochMs);
    return d.getDate() + ' ' + MONTH_NAMES[d.getMonth()] + ' ' + d.getFullYear();
  }

  // Fills ${start}/${end}/${days}/${count} into a merchant-editable template; each is only touched if supplied.
  function substitute(template, vars) {
    vars = vars || {};
    let text = template || '';
    const days = vars.days != null ? vars.days : (window.CruisePhotobookSavedBadgeConfig && window.CruisePhotobookSavedBadgeConfig.days) || 7;
    if (vars.savedAt != null) {
      text = text.replace(/\$\{start\}/g, formatDate(vars.savedAt));
      text = text.replace(/\$\{end\}/g, formatDate(vars.savedAt + days * DAY_MS));
    }
    text = text.replace(/\$\{days\}/g, days);
    if (vars.count != null) {
      text = text.replace(/\$\{count\}/g, vars.count);
    }
    return text;
  }

  // Convenience wrapper around the global template + a savedAt.
  function buildText(savedAt) {
    const config = window.CruisePhotobookSavedBadgeConfig || {};
    return substitute(config.template, { savedAt: savedAt, days: config.days });
  }

  window.CruisePhotobookSavedBadge = {
    formatDate: formatDate,
    substitute: substitute,
    buildText: buildText
  };
})();
